import { render, staticRenderFns } from "./det.vue?vue&type=template&id=1aa8c3e2"
import script from "./det.vue?vue&type=script&lang=js"
export * from "./det.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports